<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="退出登录" title="平板作业" @click-left="onClickLeft"/>
    <van-tabs @click="onTabClicked">
      <van-tab title="任务汇总">
        <van-row gutter="20">
          <van-col span="8">
            <van-field :value="storageRoom.name" label="库房" name="storageRoomPicker" readonly right-icon="clear" @focus="showStorageRoom=true" @click-right-icon="clearStorageRoom"/>
            <van-popup v-model="showStorageRoom" position="bottom">
              <van-picker :columns="storageRooms" show-toolbar value-key="name" @cancel="showStorageRoom = false" @confirm="onStorageRoomSelected"/>
            </van-popup>
          </van-col>
          <van-col span="8">
            <van-field :value="wave" label="波次" name="wavePicker" readonly right-icon="clear" @focus="showWave=true" @click-right-icon="clearWave"/>
            <van-popup v-model="showWave" position="bottom">
              <van-picker :columns="waves" show-toolbar value-key="name" @cancel="showWave=false" @confirm="onWaveSelected"/>
            </van-popup>
          </van-col>
        </van-row>
        <vxe-table ref="tab1" :data="list" :loading="loading">
          <vxe-column fixed="left" type="seq" width="40"/>
          <vxe-column field="wave" title="波次号"/>
          <vxe-column field="location.no" title="货位"/>
          <vxe-column field="zone.no" title="区域"/>
          <vxe-column field="taskGroup" title="分组号"/>
          <vxe-column field="cases" title="箱数"/>
        </vxe-table>
        <van-tabbar fixed placeholder>
          <van-tabbar-item align="center">
            <van-button block round style="margin: 8px;width: 200px" type="info" @click="refreshList">查询</van-button>
          </van-tabbar-item>
          <van-tabbar-item align="center">
            <van-button block round style="margin: 8px;width: 200px" type="primary" @click="init">预注册</van-button>
          </van-tabbar-item>
          <van-tabbar-item align="center">
            <van-button :loading="loading" block round style="margin: 8px;width: 200px" type="primary" @click="obtain">索取</van-button>
          </van-tabbar-item>
        </van-tabbar>
      </van-tab>
      <van-tab title="索取未确认">
        <vxe-table ref="tab2" :data="tasks" :loading="loading">
          <vxe-column fixed="left" type="seq" width="40"/>
          <vxe-column field="name" title="区域"/>
          <vxe-column field="taskGroup" title="分组号"/>
        </vxe-table>
        <van-tabbar fixed placeholder>
          <van-tabbar-item align="center">
            <van-button block round style="margin: 8px;width: 200px" type="info" @click="refreshTask">刷新</van-button>
          </van-tabbar-item>
          <van-tabbar-item align="center">
            <van-button block round style="margin: 8px;width: 200px" type="primary" @click="bind">绑箱</van-button>
          </van-tabbar-item>
        </van-tabbar>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import api from '@/api'
import { findAll, post } from '@/api/Api'
import { getUser, getUserId, getWarehouseId } from '@/pdaView/utils'
import { Dialog, Toast } from 'vant'

export default {
  name: 'PadIndex',
  data() {
    return {
      loading: false,
      username: getUser().name,
      storageRoom: { id: null, name: '' },
      wave: null,
      storageRooms: [],
      waves: [],
      showStorageRoom: false,
      showWave: false,
      currentContact: {},
      list: [],
      tasks: []
    }
  },
  activated() {
    this.getStorageRooms()
    this.getWaves()
    this.refreshList()
  },
  methods: {
    goIndex() {
      this.$router.push({ name: 'PadIndex' })
    },
    onClickLeft() {
      Dialog.confirm({
        title: '退出',
        message: '确定退出?'
      }).then(() => {
        localStorage.removeItem('warehouseId')
        localStorage.removeItem('userId')
        localStorage.removeItem('user')
        localStorage.removeItem('type')
        localStorage.removeItem('ip')
        this.$router.push({ name: 'PdaLogin' }, () => {
          Toast('退出成功')
        })
      })
    },
    onTabClicked(that) {
      if (that === 0) {
        this.refreshList()
      } else {
        this.refreshTask()
      }
    },
    getStorageRooms() {
      const args = {
        'picker.id': getUserId(),
        application: 4,
        available: true
      }
      findAll('pickerConfigFactory', args).then(res => {
        if (res.success && res.result.length > 0) {
          this.storageRooms = []
          res.result.map(it => {
            this.storageRooms.push({
              id: it.storageRoom.id,
              name: it.storageRoom.name
            })
          })
        }
      })
    },
    onStorageRoomSelected(item) {
      this.storageRoom = item
      this.showStorageRoom = false
    },
    getWaves() {
      findAll('pickingOrderWaveListFactory', { 'user.id': getUserId(), application: 4 }).then(res => {
        if (res.success && res.result.length > 0) {
          this.waves = []
          res.result.map(item => {
            this.waves.push({
              name: item.wave
            })
          })
        }
      })
    },
    onWaveSelected(item) {
      this.wave = item.name
      this.showWave = false
    },
    refreshList() {
      this.loading = true
      this.list = []
      const args = {
        'storageRoom.id': this.storageRoom.id,
        'wave': this.wave,
        'user.id': getUserId(),
        application: 4
      }
      findAll('pickingOrderListFactory', args, 1, 10).then(res => {
        if (res.success) {
          this.list = res.result
        }
      }).finally(() => this.loading = false)
    },
    refreshTask() {
      this.loading = true
      const args = {
        'warehouse.id': getWarehouseId(),
        workMode: 5,
        'user.id': getUserId(),
        device: false
      }
      findAll('pickingObtainedGroupFactory', args).then(res => {
        if (res.success) {
          this.tasks = res.result
        }
      }).finally(() => this.loading = false)
    },
    clearStorageRoom() {
      this.storageRoom = { id: null, name: '' }
    },
    clearWave() {
      this.wave = null
      this.refreshList()
    },
    init() {
      this.loading = true
      const args = {
        wave: this.wave ? this.wave : null
      }
      post(api.pickingInit, {}, args).then(res => {
        if (res.success) {
          Toast('预注册成功')
          this.refreshList()
        }
      }).finally(() => this.loading = false)
    },
    obtain() {
      const currentRow = this.$refs.tab1.getCurrentRecord()
      if (!currentRow) {
        Toast('请选择一行数据')
        return
      }
      this.loading = true
      const args = {
        'workMode': 5,
        'taskGroup': currentRow.taskGroup
      }
      post(api.pickingObtain, { type: 'pickingOrderObtainer' }, args).then(res => {
        if (res.success) {
          this.$router.push({ name: 'Binding', params: { taskGroup: res.result.taskGroup } })
        } else {
          Toast(res.result)
        }
      }).finally(() => this.loading = false)
    },
    bind() {
      const currentRow = this.$refs.tab2.getCurrentRecord()
      if (!currentRow) {
        Toast('请选择一行数据')
        return
      }
      this.$router.push({ name: 'Binding', params: { taskGroup: currentRow.taskGroup } })
    },
    getOperationType(operationType) {
      if (operationType === 1) {
        return '入库'
      } else if (operationType === 2) {
        return '出库'
      } else if (operationType === 3) {
        return '补货'
      } else if (operationType === 4) {
        return '移库'
      } else if (operationType === 5) {
        return '盘点'
      } else if (operationType === 6) {
        return '质检'
      } else if (operationType === 7) {
        return '转换'
      } else if (operationType === 8) {
        return '回库'
      } else if (operationType === 9) {
        return '演示'
      } else if (operationType === 10) {
        return '接收'
      }
    }
  }
}
</script>